module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "action": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action"])},
        "no_data_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No data available"])}
      },
      "cn": {
        "action": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作"])},
        "no_data_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["没有数据"])}
      }
    }
  })
  Component.options.__i18nBridge = Component.options.__i18nBridge || []
  Component.options.__i18nBridge.push('{"en":{"action":"Action","no_data_text":"No data available"},"cn":{"action":"操作","no_data_text":"没有数据"}}')
  delete Component.options._Ctor
  
}
